"use client";

import { useState, useEffect } from "react";
import { IconChevronRight, IconLoader2 } from "@tabler/icons-react";
import { cn } from "@/lib/utils";

export default function FUIForm() {
  const [pending, setPending] = useState(false);
  const [isMobile, setIsMobile] = useState(false);
  const [formData, setFormData] = useState({
    firstName: "",
    lastName: "",
    email: "",
    message: "",
  });

  useEffect(() => {
    const checkMobile = () => setIsMobile(window.innerWidth < 768);
    checkMobile();
    window.addEventListener("resize", checkMobile);
    return () => window.removeEventListener("resize", checkMobile);
  }, []);

  const handleChange = (e: React.ChangeEvent<HTMLInputElement | HTMLTextAreaElement>) => {
    setFormData({ ...formData, [e.target.name]: e.target.value });
  };

  const onSubmit = (e: React.FormEvent) => {
    e.preventDefault();
    setPending(true);
    // Simulate submission
    setTimeout(() => {
        setPending(false);
        alert("Mensagem enviada! Entraremos em contato.");
        setFormData({ firstName: "", lastName: "", email: "", message: "" });
    }, 1500);
  };

  return (
    <section id="diagnostico" className="relative py-24 bg-black">
      <div className="absolute inset-0 bg-[url('/grid.svg')] opacity-10 pointer-events-none" />
      <div className="relative z-10 max-w-4xl mx-auto px-6">
        <div className="md:text-center mb-12">
            <h2 className="text-3xl md:text-5xl font-bold text-white mb-4">
                Pronto para <span className="text-midas-yellow-500">Acelerar?</span>
            </h2>
            <p className="text-neutral-400 text-lg">
                Preencha o formulário abaixo e agende seu diagnóstico gratuito.
            </p>
        </div>

        <div className={cn(
            "w-full max-w-2xl mx-auto p-8 rounded-3xl bg-neutral-900/50 border border-neutral-800",
            !isMobile && "backdrop-blur-sm"
        )}>
            <form className="space-y-6" onSubmit={onSubmit}>
              <div className="grid grid-cols-1 md:grid-cols-2 gap-6">
                <div className="space-y-2">
                  <label htmlFor="firstName" className="text-sm font-medium text-neutral-300">Nome</label>
                  <input
                    id="firstName"
                    name="firstName"
                    value={formData.firstName}
                    onChange={handleChange}
                    placeholder="Seu nome"
                    required
                    className="w-full px-4 py-3 bg-neutral-950 border border-neutral-800 rounded-xl text-white focus:outline-none focus:ring-2 focus:ring-midas-yellow-500/50 focus:border-midas-yellow-500 transition-all placeholder:text-neutral-600"
                  />
                </div>
                <div className="space-y-2">
                  <label htmlFor="lastName" className="text-sm font-medium text-neutral-300">Sobrenome</label>
                  <input
                    id="lastName"
                    name="lastName"
                    value={formData.lastName}
                    onChange={handleChange}
                    placeholder="Seu sobrenome"
                    className="w-full px-4 py-3 bg-neutral-950 border border-neutral-800 rounded-xl text-white focus:outline-none focus:ring-2 focus:ring-midas-yellow-500/50 focus:border-midas-yellow-500 transition-all placeholder:text-neutral-600"
                  />
                </div>
              </div>

              <div className="space-y-2">
                <label htmlFor="email" className="text-sm font-medium text-neutral-300">Email Corporativo</label>
                <input
                  id="email"
                  name="email"
                  type="email"
                  value={formData.email}
                  onChange={handleChange}
                  placeholder="voce@SuaEmpresa.com"
                  required
                  className="w-full px-4 py-3 bg-neutral-950 border border-neutral-800 rounded-xl text-white focus:outline-none focus:ring-2 focus:ring-midas-yellow-500/50 focus:border-midas-yellow-500 transition-all placeholder:text-neutral-600"
                />
              </div>

              <div className="space-y-2">
                <label htmlFor="message" className="text-sm font-medium text-neutral-300">Desafio Atual</label>
                <textarea
                  id="message"
                  name="message"
                  value={formData.message}
                  onChange={handleChange}
                  required
                  maxLength={500}
                  rows={4}
                  placeholder="Qual é o maior gargalo da sua operação hoje?"
                  className="w-full px-4 py-3 bg-neutral-950 border border-neutral-800 rounded-xl text-white focus:outline-none focus:ring-2 focus:ring-midas-yellow-500/50 focus:border-midas-yellow-500 transition-all placeholder:text-neutral-600 resize-none"
                />
              </div>

              <button
                disabled={pending}
                type="submit"
                className="w-full relative flex items-center justify-center px-8 py-4 text-lg font-bold text-black transition-all duration-200 bg-midas-yellow-500 rounded-xl hover:bg-midas-yellow-400 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-midas-yellow-500 ring-offset-black disabled:opacity-50 disabled:cursor-not-allowed"
              >
                {pending ? (
                   <IconLoader2 className="animate-spin w-6 h-6" />
                ) : (
                  <>
                    <span>Solicitar Diagnóstico</span>
                    <IconChevronRight className="w-5 h-5 ml-2" />
                  </>
                )}
              </button>
            </form>
        </div>
      </div>
    </section>
  );
}
// import { Label } from "@/components/ui/label";
// import { Input } from "@/components/ui/input";
// import { Textarea } from "@/components/ui/textarea";
// import { ChevronRight, Loader2 } from "lucide-react";
// import { useState, useTransition } from "react";
// import { useToast } from "@/components/ui/use-toast";
// // raplace it with your actions.
// import { saySomething } from "actions/emailSubRelated";
// import {Button} from "@/components/ui/button";
// type FormType = {
//   firstName: string;
//   lastName?: string;
//   email: string;
//   message: string;
// };
// export default function FUIForm() {
//   const [pending, startTransition] = useTransition();
//   const { toast } = useToast()

//   const [forms, setForms] = useState({
//     firstName: "",
//     lastName: "",
//     email: "",
//     message: "",
//   });
  
//   const handleChange = (e: any) => {
//     setForms({ ...forms, [e.target.name]: e.target.value });
//   };
//   const onSubmit = (e:any) => {
//     e.preventDefault();
//     startTransition(async () => {
//       saySomething({
//         firstName: forms.firstName,
//         lastName: forms.lastName,
//         email: forms.email,
//         message: forms.message,
//       })
//         .then((res) => {
//           toast({
//             position: "bottom-left",
//             title: "Message submitted",
//             description:
//               "You have successfully submitted your message. we will keep in touch with you with the speed of light :)",
//           });
//           setForms({
//             firstName:"",
//             lastName:"",
//             email: "",
//             message: ""
//           })
//         })
//         .catch((err) => {
//           toast({
//             position: "bottom-left",

//             title: "Something went wrong",
//             description:
//               "There is an error while submitting the form, Please try again later :(",
//             variant: "destructive",

//           });
//         });
//     });
//   };
//   return (
//     <section className="custom-screen-lg mx-auto z-20">
//       <div className="relative backdrop-blur-3xl z-10 max-w-4xl mx-auto  space-y-4">
//         <Card className="relative mt-20 py-10 z-20 backdrop-blur-3xl">
//           <CardHeader>
//             <CardDescription>
//               Fill out the form below and we'll get back to you as soon as
//               possible.
//             </CardDescription>
//           </CardHeader>
//           <CardContent>
//             <div className=""></div>
//             <form className="space-y-4 z-20" onSubmit={onSubmit}>
//               <div className="grid grid-cols-1 md:grid-cols-2 gap-4 z-20">
//                 <div className="space-y-2">
//                   <Label htmlFor="first-name">First Name</Label>
//                   <Input

//                     value={forms.firstName}
//                     onChange={(e) => handleChange(e)}
//                     name="firstName"
//                     placeholder="Enter your first name"
//                     required
//                   />
//                 </div>
//                 <div className="space-y-2">
//                   <Label htmlFor="last-name">Last Name</Label>
//                   <Input
//                     value={forms.lastName}
//                     onChange={handleChange}
//                     name="lastName"
//                     placeholder="Enter your last name"
//                   />
//                 </div>
//               </div>
//               <div className="space-y-2">
//                 <Label htmlFor="email">Email</Label>
//                 <Input

//                   value={forms.email}
//                   name="email"
//                   onChange={handleChange}
//                   placeholder="Enter your email"
//                   type="email"
//                   required
//                 />
//               </div>
//               <div className="space-y-2">
//                 <Label htmlFor="message">Message</Label>
//                 <Textarea
//                   required
//                   value={forms.message}
                  
//                    className="bg-transparent"
//                    onChange={handleChange}
//                   name="message"
//                   maxLength={200}
                  
//                   placeholder="Enter your message"
//                 />
//               </div>
//                 <Button
//                   disabled={pending}
//                   variant="default"
//                   className="inline-flex rounded-3xl  text-center group items-center w-full justify-center bg-gradient-to-tr from-black/90 via-zinc-800 to-black  border-input border-[1px] hover:bg-transparent/10 transition-colors sm:w-auto py-6 px-10"
//                 >
//                   Submit
//                   {pending ? (
//                     <Loader2 className="animate-spin ml-3 w-4 h-4 flex items-center" />
//                   ) : (
//                     <ChevronRight className="w-4 h-4 ml-2 group-hover:translate-x-1 duration-300" />
//                   )}
//                 </Button>
//             </form>
//           </CardContent>
//         </Card>
//       </div>
//     </section>
//   );
// }


